import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import { PencilSimpleIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { CountryFlag, IconButton, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const LocationInfoSection = ({ title, editTooltip, address, locationName, locationLabel, onEdit, allowEdit }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.SectionContainer>
      <Styles.SectionTitleContainer>
        <Text type="titleS">{title}</Text>

        <Styles.ActionsTitleContainer>
          {allowEdit && (
            <Tooltip title={editTooltip}>
              <IconButton
                variant="text"
                icon={<PencilSimpleIcon alt={editTooltip} size={24} color={theme.colors.outline.default} />}
                onClick={onEdit}
              />
            </Tooltip>
          )}
        </Styles.ActionsTitleContainer>
      </Styles.SectionTitleContainer>
      <Styles.SectionInfoContainer>
        {locationName && (
          <Styles.InfoColumnContainer>
            <Styles.InfoContainer>
              <Text type="bodyMRegular" color={theme.colors.text.subtle}>
                {locationLabel}
              </Text>
              <Text type="bodyMRegular">{locationName}</Text>
            </Styles.InfoContainer>
          </Styles.InfoColumnContainer>
        )}
        <Styles.InfoColumnContainer>
          <Styles.InfoContainer>
            <Text type="bodyMRegular" color={theme.colors.text.subtle}>
              {t('Dirección')}
            </Text>
            <div>
              <Text type="bodyMRegular">
                {address?.line_1} {address?.line_2} {address?.house_number}
              </Text>
              <Text type="bodyMRegular">
                {address?.postcode} {address?.locality} {address?.province?.name}
              </Text>
              <Text type="bodyMRegular">
                {address?.country?.name} <CountryFlag code={address?.country?.code} />
              </Text>
            </div>
          </Styles.InfoContainer>
          {address?.phone && (
            <Styles.InfoContainer>
              <Text type="bodyMRegular" color={theme.colors.text.subtle}>
                {t('Teléfono')}
              </Text>
              <Text type="bodyMRegular">
                +{address?.phone?.prefix} {address?.phone?.number}
              </Text>
            </Styles.InfoContainer>
          )}
        </Styles.InfoColumnContainer>
      </Styles.SectionInfoContainer>
    </Styles.SectionContainer>
  )
}

export default LocationInfoSection
